import React from 'react';
import PropTypes from 'prop-types';
import { escapeHTML } from '../../../utils';
import { getAnswerClass } from '../utils';
import ReactIcon from '../../Icons';

const zoomIcon = ReactIcon({ type: 'zoom_in' });

export default function AnswerWithImage({
  answer,
  question,
  containsOnlyEmoji,
}) {
  const imageToShow = answer.optimized_image_url || answer.image_url;
  const originalAnswerImage = answer.image_url;
  const answerClass = getAnswerClass({ question, answer, containsOnlyEmoji });
  return (
    <div id={answer.id} className={`answer answer--with-image ${answerClass}`}>
      <div className="answer__image__container">
        <img
          src={imageToShow}
          alt={escapeHTML(answer.body)}
          className="answer__image"
        />
        <button
          type="button"
          className="answer__image__button js-zoom-image"
          data-img-src={originalAnswerImage}
        >
          {zoomIcon}
        </button>
      </div>
      <div
        className="answer__description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: answer.body || '&nbsp;' }}
      ></div>
    </div>
  );
}

AnswerWithImage.propTypes = {
  answer: PropTypes.object,
  question: PropTypes.object,
  containsOnlyEmoji: PropTypes.bool,
};
